<template>
    <dialog-modal :show="show" @close="close">
        <template #title>
            <div class="flex items-center justify-between">
                <!--                <span class="pr-12 sm:pr-0">Share This Challenge With Everyone</span>-->
                <span></span>
                <modal-close @close="close" />
            </div>
        </template>
        <template #content>
            <div class="flex flex-col items-center space-y-8 pb-4">
                <div class="flex grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-4 items-center justify-center w-full">
                    <a :href="post.shareUrls.facebook" target="_blank" class="sm:hidden col-span-2 flex flex-col items-center space-y-2 hover:bg-gray-50 dark:hover:bg-slate-600/50 px-3 py-4 rounded-lg hover:shadow-sm text-gray-500 hover:text-gray-700 dark:hover:text-white text-sm">
                        <sms-icon class="w-16 h-16 sm:w-20 sm:h-20 filter drop-shadow" />
                        <span>Text Message</span>
                    </a>
                    <a :href="post.shareUrls.facebook" target="_blank" class="flex flex-col items-center space-y-2 hover:bg-gray-50 dark:hover:bg-slate-600/50 px-3 py-4 rounded-lg hover:shadow-sm text-gray-500 hover:text-gray-700 dark:hover:text-white text-sm">
                        <facebook-icon class="w-16 h-16 sm:w-20 sm:h-20 filter drop-shadow" />
                        <span>Facebook</span>
                    </a>
                    <a :href="post.shareUrls.twitter" target="_blank" class="flex flex-col items-center space-y-2 hover:bg-gray-50 dark:hover:bg-slate-600/50 px-3 py-4 rounded-lg hover:shadow-sm text-gray-500 hover:text-gray-700 dark:hover:text-white text-sm">
                        <twitter-icon class="w-16 h-16 sm:w-20 sm:h-20 filter drop-shadow" />
                        <span>Twitter</span>
                    </a>
                    <a :href="post.shareUrls.snapchat" target="_blank" class="flex flex-col items-center space-y-2 hover:bg-gray-50 dark:hover:bg-slate-600/50 px-3 py-4 rounded-lg hover:shadow-sm text-gray-500 hover:text-gray-700 dark:hover:text-white text-sm">
                        <snapchat-icon class="w-16 h-16 sm:w-20 sm:h-20 filter drop-shadow" />
                        <span>Snapchat</span>
                    </a>
                    <a :href="post.shareUrls.telegram" target="_blank" class="flex flex-col items-center space-y-2 hover:bg-gray-50 dark:hover:bg-slate-600/50 px-3 py-4 rounded-lg hover:shadow-sm text-gray-500 hover:text-gray-700 dark:hover:text-white text-sm">
                        <telegram-icon class="w-16 h-16 sm:w-20 sm:h-20 filter drop-shadow" />
                        <span>Telegram</span>
                    </a>
                    <a :href="post.shareUrls.whatsapp" target="_blank" class="flex flex-col items-center space-y-2 hover:bg-gray-50 dark:hover:bg-slate-600/50 px-3 py-4 rounded-lg hover:shadow-sm text-gray-500 hover:text-gray-700 dark:hover:text-white text-sm">
                        <whatsapp-icon class="w-16 h-16 sm:w-20 sm:h-20 filter drop-shadow" />
                        <span>Whatsapp</span>
                    </a>
                    <a :href="post.shareUrls.reddit" target="_blank" class="flex flex-col items-center space-y-2 hover:bg-gray-50 dark:hover:bg-slate-600/50 px-3 py-4 rounded-lg hover:shadow-sm text-gray-500 hover:text-gray-700 dark:hover:text-white text-sm">
                        <reddit-icon class="w-16 h-16 sm:w-20 sm:h-20 filter drop-shadow" />
                        <span>Reddit</span>
                    </a>
                </div>

                <div class="w-full mx-4">
                    <label :for="'short_url_' + post.id" class="flex items-center justify-between text-sm text-gray-700 dark:text-slate-400">
                        <span>Copy Link</span>
                        <span v-if="textCopied" class="flex items-center space-x-2 font-medium text-blue-500">
                            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                            </svg>
                            copied
                        </span>
                    </label>
                    <div class="mt-1 flex rounded-lg shadow-sm">
                        <div class="relative flex items-stretch flex-grow focus-within:z-10">
                            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <!-- Heroicon name: solid/link -->
                                <svg class="h-5 w-5 text-gray-400 dark:text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                                </svg>
                            </div>
                            <input @focus="copyToClipboard(post.shortUrl)" type="text" :value="post.shortUrl" :id="'short_url_' + post.id" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md pl-10 sm:text-sm border-gray-300" />
                        </div>
                        <button
                            @click="copyToClipboard(post.shortUrl)"
                            class="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                        >
                            <svg class="h-5 w-5 text-gray-400 dark:text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                            </svg>
                            <span class="sr-only">Copy</span>
                        </button>
                    </div>
                    <p class="mt-2 text-xs text-gray-500 dark:text-slate-400">Post this link anywhere you want.</p>
                </div>
            </div>
        </template>
    </dialog-modal>
</template>

<script>
import DialogModal from "@/Jetstream/DialogModal"
import FacebookIcon from "@/ProviderIcons/FacebookIcon"
import TwitterIcon from "@/ProviderIcons/TwitterIcon"
import RedditIcon from "@/ProviderIcons/RedditIcon"
import WhatsappIcon from "@/ProviderIcons/WhatsappIcon"
import TelegramIcon from "@/ProviderIcons/TelegramIcon"
import ModalClose from "@/Components/ModalClose"
import SnapchatIcon from "@/ProviderIcons/SnapchatIcon"
import SmsIcon from "@/ProviderIcons/SmsIcon"

export default {
    components: {
        SmsIcon,
        SnapchatIcon,
        ModalClose,
        TelegramIcon,
        WhatsappIcon,
        RedditIcon,
        TwitterIcon,
        FacebookIcon,
        DialogModal,
    },

    props: {
        show: {
            default: false,
        },
        post: {
            required: true,
        },
    },

    data() {
        return {
            textCopied: false, // value updated by copyToClipboard() mixins.js
        }
    },

    methods: {
        close() {
            this.textCopied = false
            this.$emit("update:show", false)
        },
    },
}
</script>
